<template>
  <div class="menu">
      <el-scrollbar wrap-class="scrollbar-wrapper">
        <el-menu
            :default-active="activeMenu"
            :collapse="false"
            :unique-opened="false"
            :collapse-transition="false"
            mode="vertical"
        >
            <sidebar-item v-for="route in asideRouters" :key="route.path" :item="route" :base-path="route.path" />
        </el-menu>
       </el-scrollbar> 
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem},
  computed: {
    ...mapGetters([
      'asideRouters',
   
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    isCollapse() {
      return true
    }
  },
  created() {
    console.log(this.asideRouters);
  }
}
</script>

<style scoped>
.menu{height: 100%;border-right: #eaeaea 1px solid;}
.menu >>> .el-menu{border-width: 0;}
.scrollbar-wrapper {overflow-x: hidden !important;}
</style>
